import { Border, Font, Spacings } from "@ptml/design-system";
import styled from "styled-components";
import { RobotSignalVariantTokens } from "./RobotSignal.tokens";
import {
    RobotSignalVariantList,
    type RobotSignalVariant,
} from "./RobotSignal.types";

export const RobotSignalBadgeWrapper = styled.div<{
    $variant: RobotSignalVariant;
}>`
    display: inline-flex;
    align-items: center;
    gap: ${Spacings.xxxsmall};
    width: fit-content;
    box-sizing: border-box;
    max-height: 22px;
    padding: 3px 6px;
    border-radius: ${Border.Radius.Size["4"]};
    background: ${({ $variant = RobotSignalVariantList.SOLID_PURPLE }) =>
        RobotSignalVariantTokens[$variant].background()};
    line-height: normal;
    flex-shrink: 0;
`;

export const RobotSignalBadgeText = styled.span<{
    $variant: RobotSignalVariant;
}>`
    font-size: ${Font.size[14]};
    font-weight: ${Font.weight.regular};
    color: ${({ $variant = RobotSignalVariantList.SOLID_PURPLE }) =>
        RobotSignalVariantTokens[$variant].textColor};
    white-space: nowrap;
`;
